import $ from 'jquery';
import Bloodhound from 'vendor/typeahead';
import Mustache from 'mustache';

export default {
    init() {
        initSearchBar();
        if(window.rcProps && typeof window.rcProps.get === 'function') {
            initVisualSearch()
        }
    }
};



function initSearchBar() {
        // New Search
        var textboxInput = $('.site-search__input');
        var cancelSearch = $('.form-search__x');
        var searchForm = $('.js-site-search');
        var searchBtn = $('#search-button');
        var closeBtn = $('#js-search-close');
        var searchOverlay;

        var createOverlay = function(e) {
            searchOverlay = $('<div>', {
                class: 'site-search__overlay'
            });

            return searchOverlay;
        };

        var updateField = function(e) {
            if( textboxInput.val().length > 0 ) {
                cancelSearch.addClass('is-active');
            } else {
                cancelSearch.removeClass('is-active');
            }
        };

        var clearInput = function() {
            cancelSearch.removeClass('is-active');
            $('#search-input').typeahead('val', '');
        };

        var closeSearch = function() {
            searchForm.fadeOut(400, function() {

            });
            searchOverlay.removeClass('site-search__overlay--active');
            $('.js-site-search').attr('aria-modal', false);
            $('.site-search__results').attr('aria-expanded', false);
            clearInput();
        };

        var openSearch = function(e) {
            searchForm.show();
            textboxInput.focus();
            searchOverlay.addClass('site-search__overlay--active');
            logEngagement('Search Box');
        };

        var addEventListeners = function() {
            cancelSearch.on('click', clearInput);
            searchBtn.on('click', openSearch);
            closeBtn.on('click', closeSearch);
            textboxInput.keyup(updateField);
            searchOverlay.on('click', closeSearch);
        };

        var initSearch = function() {
            createOverlay();
            addEventListeners();
        }

        initSearch();

}

function initVisualSearch(){
    if(!window.rcProps) return;
        /*
         Suggestive Search
         =================
         */

        // Products
        var products = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace("productName"),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: '/r/ajax/VisualSearch.jsp?fw=true&q=%QUERY&d='+ rcProps.department,
                wildcard: '%QUERY'
            }
        });

        // Text Suggestions
        var textSuggestions = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace("searchTerm"),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: '/r/ajax/TextSuggestions.jsp?fw=true&q=%QUERY&d='+rcProps.department,
                wildcard: '%QUERY'
            }
        });
        // Creates typeahead feature on search box.
        $('#search-input').typeahead(
            {
                hint: false,
                highlight: true,
                minLength: window.rcProps.search.minCharLengthForSearching,
                classNames: {
                    menu: 'site-search__results',
                    dataset: "g n-block-grid--1"
                }
            },
            {

                name: 'textSuggestions',
                display: function (obj) {
                    return obj.suggestion;
                },
                source: textSuggestions,
                templates: {
                    suggestion: function (data) {
                        return Mustache.render(rcProps.get("search.text.templates.line"), data);
                    }
                },
                limit: rcProps.get("search.text.limit")
            },
            {
                name: 'recent',
                display: function(obj) {
                    return obj.searchText;
                },
                source: function(query, callback) {
                    callback(rcProps.get('search.recent.json'));
                },
                templates: {
                    suggestion: function(data) {
                        return Mustache.render(rcProps.get('search.recent.template'), data);
                    }
                },
            },
            {
                name: 'productSuggestions',
                display: 'productName',
                source: products,
                templates: {
                    header: function() {
                        $(function() {
                            $("#js-search-hed-target").parent().before($("#js-search-hed-target"));
                        });
                        $('#js-search-hed-target').first().remove();
                        return rcProps.get("search.visual.templates.header");
                    },
                    suggestion: function (data) {
                        $(".site-search__results .n-block-grid--1-productSuggestions").removeClass("g n-block-grid--1").addClass("horizontal-scroll u-flex");
                        return Mustache.render(rcProps.get("search.visual.templates.line"), data);
                    },
                    notFound: function() {
                        $('.n-block-grid--1-productSuggestions').removeClass('horizontal-scroll');
                        $('.product-suggestions__title').remove();
                    }
                },
                limit: rcProps.get("search.visual.limit")
            }
        ).on('typeahead:select', function (event, suggestion) {
            logEngagement("click_search_suggestion_" + (suggestion.termType || "search"));
            if ("productURL" in suggestion) {
                window.location.href = suggestion.productURL;
            } else if ("suggestionUrl" in suggestion) {
                window.location.href = suggestion.suggestionUrl;
            } else if ('href' in suggestion) { // Recent search
                window.location.href = suggestion.href;
            } else {
                var href = '/content/s/ct?type=' + suggestion.typeShortCode + '&q=' + suggestion.searchTerm + '&s=' + suggestion.suggestion + '&d=' + rcProps.get("department");
                window.location.href = href;
            }
        }).on('typeahead:render', function($e) {
            /**
             * we're showing 5 recently searches initially,
             * but as you type, show only 3 max.
             */             
            if($('#search-input').val().length > 0) {
                $('.n-block-grid--1-recent li').slice(3).hide();
            } else {
                $('.n-block-grid--1-recent li').slice(3).show();
            }
        });

        $(".tt-dropdown-menu")
            .addClass("site-search__predictions")
            .css({
                "left": "",
                "z-index": "",
                "right": ""
            });
        $(".twitter-typeahead").addClass("site-search__typeahead form-search__input").css({'width': '60%'});
        $(".tt-dataset-textSuggestions").addClass("site-search__suggestions");
        // remove once UX-9169 has been implemented
        $(".site-search__results div").first().removeClass("g n-block-grid--2  n-block-grid--2-textSuggestions");
        // $(".site-search__results-wrap div").first().removeClass("g n-block-grid--2  n-block-grid--2-textSuggestions");
        $(".tt-dataset-products").addClass("g")
            .addClass("n-block-grid--2");
        $(".tt-highlight").addClass("site-search__highlight");
        $(".tt-dataset-products").addClass("predict-related");
        // remove once UX-9169 has been implemented
        $('.site-search__results').insertAfter(".site-search");
        // $('.site-search__results-wrap').insertAfter(".site-search");
        //$('.site-search__results').css({ display:"inline-block" });
        // remove once UX-9169 has been implemented
        $('.site-search__results').css({ width: "100%" });
        // $('.site-search__results-wrap').css({ width: "100%" });
        $('.site-search__results').css({ 'padding-bottom': '17px' });
        // $('.site-search__results-wrap').css({ 'padding-bottom': '17px' });
        $('.js-site-search').attr('aria-modal', true);
        $('.site-search__results').attr('aria-expanded', true);
}

function logEngagement(action) {
    $.ajax({
        type: 'POST',
        data: $.param({
            url: window.location.href,
            module: "mobile_search",
            action: action
        }),
        url: '/r/ajax/LogEngagement.jsp'
    });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/search.js